(function() {
    const closingIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="https://www.w3.org/2000/svg">
<path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
</svg>`;

    const lang = document.documentElement.lang;

    const translations = {
        "en-GB": {
            'titleEvents': 'Next Event',
            'titleEventsAnd': "and",
            'thisSession': "Choose one slot:",
            'eventWarningCancel': "Sorry, the event you're looking to cancel is in the past.",
            'eventWarningUpdate': "Sorry, the event you're looking to reschedule is in the past.",
            'directions': "Directions",
            'revervationTo': "Booking for",
            'bookingReservedAt': 'Your booking was reserved to',
            'bookingConfirmedAt': 'at',
            'confirmationEmail': 'In a few minutes you will receive a confirmation email.',
            'bookingCancelTitle': 'Cancel Event',
            'bookingCanceled': 'Your booking was canceled.',
            'bookingCanceledTitle': 'Booking Canceled!',
            'bookingCanceledText': 'Please confirm that you would like to cancel this event.',
            'bookingCanceledCtaNo': 'No, Don\'t Cancel',
            'bookingCanceledCtaYes': 'Yes, Cancel',
            'submitBooking': 'Submit Booking',
            'name': 'Name',
            'comments': 'Comments',
            'qty': 'How Many Guests (Besides you)',
            'bookingConfirmed': 'Booking Confirmed!',
            'bookingUpdateConfirmed': 'Re-schedule Confirmed!',
            'multiplePlacesTitle': 'Events for this date',
            'fullyBooked': 'Fully Booked:',
            'eachReservationMax': '(Each reservation allows up to 3 people)',
            'noEventsPlanned': "We are preparing next month's pop ups &#128521;",
            'checkEventsNextMonth': 'Check events next Month',
            'termsRegisterPermanentJewelry': 'By signing up for a permanent bracelet session at Forever Bond Studio, you agree to the following <a title="Terms and Conditions of Registration for the Permanent Bracelet Session" href="https://foreverbondstudio.com/en/terms-and-conditions-of-registration-for-the-permanent-bracelet-session/">terms and conditions</a>',
            'termsNewsletter': 'I want to receive all the exclusive offers and events from Forever Bond Studio! I accept the <a target="_blank" title="Privacy Policy" href="https://foreverbondstudio.com/en/privacy-policy/">Privacy Policy</a> and <a target="_blank" title="Terms and Conditions" href="https://foreverbondstudio.com/en/terms-conditions/">Terms and Conditions</a>.',
            'nextEventOnThisCityWillBe': 'Next event in ',
            'nextEventOnThisCityDay': 'will be on ',
        },
        "pt-PT": {
            'titleEvents': 'Próximos eventos:',
            'titleEventsAnd': "e",
            'thisSession': "Escolha um horário:",
            'eventWarningCancel': "Desculpe, o evento que deseja cancelar já aconteceu.",
            'eventWarningUpdate': "Desculpe, o evento que deseja re-agendar já aconteceu.",
            'directions': "Direções",
            'revervationTo': "Reserva para",
            'bookingReservedAt': 'Tem a reserva marcada para',
            'bookingConfirmedAt': 'às',
            'confirmationEmail': 'Dentro de minutos receberá um email de confirmação.',
            'bookingCancelTitle': 'Cancelar Evento',
            'bookingCanceledText': 'Por favor, confirme que pretende cancelar este evento.',
            'bookingCanceledCtaNo': 'Não quero Cancelar',
            'bookingCanceledCtaYes': 'Sim, Cancelar',
            'bookingCanceled': 'A sua reserva foi cancelada.',
            'bookingCanceledTitle': 'Reserva Cancelada!',
            'submitBooking': 'Submeter Reserva',
            'name': 'Nome',
            'comments': 'Comentários',
            'qty': 'Quantos Convidados (para além do próprio)',
            'bookingConfirmed': 'Reserva Confirmada!',
            'bookingUpdateConfirmed': 'Reserva confirmada!',
            'multiplePlacesTitle': 'Eventos para este dia:',
            'fullyBooked': 'Lotado',
            'eachReservationMax': '(Cada reserva dá até 3 pessoas)',
            'noEventsPlanned': 'Estamos a preparar as pop ups do próximo mês &#128521;',
            'checkEventsNextMonth': 'Confira eventos no próximo mês',
            'termsRegisterPermanentJewelry': 'Ao inscrever-se numa sessão de pulseiras permanentes na Forever Bond Studio, está a concordar com os nossos <a title="Termos e Condições de Inscrição na Sessão de Pulseiras Permanentes" href="https://foreverbondstudio.com/termos-e-condicoes-de-inscricao-na-sessao-de-pulseiras-permanentes/">termos e condições</a>',
            'termsNewsletter': 'Quero receber todas as ofertas e eventos exclusivos da Forever Bond Studio! Aceito a <a target="_blank" title="Política Privacidade" href="https://foreverbondstudio.com/politica-privacidade/">Política de Privacidade</a> e <a target="_blank" title="Termos e Condições" href="https://foreverbondstudio.com/termos-e-condicoes/">Termos e Condições</a>.',
            'nextEventOnThisCityWillBe': 'Próximo evento em ',
            'nextEventOnThisCityDay': 'será no dia ',
        }
    }


    const calendarHTML = `
<div id="calendar-wrapper-main">
    <h2 id="calendar-title"></h2>
    <div id="calendar-wrapper-inside">
        <div id="calendar-wrapper">
            <div class="warning timeinthepast" id="eventInThePast" style="display:none;">
                <p id="eventInThePast_update" style="display:none;"><strong>Sorry, the event you're looking to reschedule is in the past.</strong></p>
                <p id="eventInThePast_delete" style="display:none;"><strong>Sorry, the event you're looking to cancel is in the past.</strong></p>
            </div>
            <div class="warning" id="editWarning" style="display:none;">
                <p>Hi <span id="edit-name"></span>, you are scheduled for <span id="edit-locationName"></span> on <span id="edit-date"></span> at <span id="edit-time"></span>. Choose a new date/time to reschedule </p>
            </div>
            <div id="calendar-header"></div>
            <div id="week-days">
                <div class="week-day">Sun</div>
                <div class="week-day">Mon</div>
                <div class="week-day">Tue</div>
                <div class="week-day">Wed</div>
                <div class="week-day">Thu</div>
                <div class="week-day">Fri</div>
                <div class="week-day">Sat</div>
            </div>
            <div id="calendar-days"></div>
            <div id="calendar-caption"></div>
        </div>
        <div id="timesContainerWrapper" style="display:none;">
            <div id="timesContainer"></div>
        </div>
        <div id="booking-form-wrapper" class="booking-form-wrapper" style="display:none;">
            <button type="button" class="closeBookingForm" id="closeBookingFormModal">${closingIcon}</button>
            <!--<div class="formHeader">
                <h3><span style="white-space: nowrap;"><span id="bookingFormDate"></span> às <span id="bookingFormSlot"></span></span></h3>
            </div> -->
            <div id="formLocationWrapper">

            </div>
            <div><p class="eachReservationMax">${translations[lang].eachReservationMax}</p></div>
            <form novalidade="" id="bookingForm">
                <div class="fieldWrapper">
                    <label for="userName">${translations[lang].name}</label>
                    <input type="text" id="userName" name="userName" required="">
                </div>
                <div class="fieldWrapper">
                    <label for="userEmail">Email</label>
                    <input type="email" id="userEmail" name="userEmail" required="">
                </div>
                <div class="fieldWrapper">
                    <label for="comments">${translations[lang].comments}</label>
                    <textarea id="comments" name="comments"></textarea>
                </div>
                <!-- <div>
                     <label for="qty">${translations[lang].qty}</label>
                     <input type="number" id="qty" name="qty" value="0">
                </div>-->
                <input type="hidden" id="availabilityId" name="availabilityId" value="">
                <input type="hidden" id="slot" name="slot" value="">
                <input type="hidden" id="date" name="date" value="">
                <div class="termsRegisterPermanentJewelry">
                    <p>${translations[lang].termsRegisterPermanentJewelry}</p>
                </div>

                 <div class="termsRegisterNewsletter">
                        <div class="optional">Opcional</div>
                    <label class="custom-checkbox">
                        <input type="checkbox" name="newsletter" value="yes">
                        <span>${translations[lang].termsNewsletter}</span>
                    </label>
                </div>
                <button id="submitBtn" type="submit">${translations[lang].submitBooking}</button>
                <div id="formErrors"></div>
            </form>
        </div>
        <div id="successModalWrapper" style="display:none;">
            <div class="successModal" id="successModal" class="modal">
                <div class="modal-content">
                    <h3>${translations[lang].bookingConfirmed}</h3>
                    <div id="success-modal-location-wrapper"></div>
                    <div class="success-message">
                        <p>
                            ${translations[lang].bookingReservedAt} <strong id="success-modal-slot"></strong>.
                        </p>
                        <p>
                           ${translations[lang].confirmationEmail}
                        </p>
                    </div>
                    <button class="successModalBTN" id="successModalBTN">Okay</button>
                </div>
            </div>
        </div>
        <div id="successUpdateModalWrapper" style="display:none;">
            <div class="successModal" id="successUpdateModal" class="modal">
                <div class="modal-content">
                    <h3>${translations[lang].bookingUpdateConfirmed}</h3>
                    <div id="success-modal-update-location-wrapper"></div>
                    <div class="success-message">
                        <p>
                        ${translations[lang].bookingReservedAt} <strong id="success-modal-update-slot"></strong>.
                        </p>
                    </div>
                    <button class="successModalBTN" id="successUpdateModalBTN">Okay</button>
                </div>
            </div>
        </div>
        <div class="successModal" id="successDeleteModalWrapper" style="display:none;">
            <div id="successDeleteModal" class="modal">
                <div class="modal-content">
                    <h3>${translations[lang].bookingCanceledTitle}</h3>
                    <div class="success-message">
                        <p>
                        ${translations[lang].bookingCanceled}
                        </p>
                    </div>
                    <button class="successModalBTN" id="successDeleteModalBTN">Okay</button>
                </div>
            </div>
        </div>

        <div id="cancel-event-wrapper" style="display:none;">
            <div id="cancel-event-modal">
                <h2>${translations[lang].bookingCancelTitle}</h2>
                <div id="cancel-event-location-wrapper"></div>
                <p>${translations[lang].bookingCanceledText}</p>
                <div class="cancel-event-button-wrapper">
                    <button class="secondary" id="cancel-event-button-no">${translations[lang].bookingCanceledCtaNo}</button>
                    <button id="cancel-event-button-yes">${translations[lang].bookingCanceledCtaYes}</button>
                </div>
            </div>
        </div>
    </div>
</div>
`;


    let todayGlobal; // global variable to store the original today date in the calendar
    let timeGlobal; // global variable to store the original today time in the calendar
    let currentDateGlobal; // global variable to store the selected date in the calendar. Changes when month changes
    let currentTimeGlobal; // global variable to store the selected date in the calendar
    let eventsData;
    let defaultColor = "925ced";
    color = defaultColor;
    let token;
    let action;
    let userDetails;
    let tokenValid = false;
    const hostname = window.location.hostname;
    let prefixRequests = window.location.protocol + '//' + hostname;
    window.location.port && (prefixRequests += ':' + window.location.port);
    if (hostname.includes('foreverbondstudio.local') || hostname.includes('foreverbondstudio.com')) {
        prefixRequests += "/wp-json/eventbooking/v1/"
    } else {
        prefixRequests += "/api/"
    }
    let queryDate;

    let currentSelection = {
        slot: null,
        locationWrapper: null,
        event: null
    };

    // Google Ads Conversion Fsuncion
    function gtag_report_conversion(url) {
        var callback = function () {
            if (typeof(url) != 'undefined') {
            window.location = url;
            }
        };
        gtag('event', 'conversion', {
            'send_to': 'AW-16755785105/DbYCCLHqmuYZEJH747U-',
            'event_callback': callback
        });
        return false;
    }

    document.addEventListener('DOMContentLoaded', function() {
        const params = new URLSearchParams(window.location.search);
        queryDate = params.get('date'); // '2024-05-12'
        if (queryDate) {
            const [year, month, day] = queryDate.split('-').map(num => parseInt(num, 10));
        }

        fetchCurrentDateAndEvents();
    });

    function specificDate(date){
        queryDate = date; // '2024-05-12'
        if (queryDate) {
            const [year, month, day] = queryDate.split('-').map(num => parseInt(num, 10));
        }

        fetchCurrentDateAndEvents();
    }

    function getOrCreateSpinner() {
        let spinner = document.getElementById('loadingSpinner');
        if (!spinner) {
            // If the spinner doesn't exist, create it
            spinner = document.createElement('div');
            spinner.id = 'loadingSpinner';
            spinner.innerHTML = '<div class="loader"></div>';
            document.body.appendChild(spinner); // You can change 'document.body' to any container you want
        }
        return spinner;
    }

    function activateInfiniteLoop() {
        let container = document.querySelector("#calendarContainer");
        container.style.display = 'flex';
        let spinner = getOrCreateSpinner();
        container.appendChild(spinner); // Append spinner to the container
        spinner.style.display = 'block'; // Make sure the spinner is visible
    }

    function deActivateInfiniteLoop() {
        let spinner = document.getElementById('loadingSpinner');
        if (spinner) {
            spinner.style.display = 'none'; // Hide the spinner instead of removing it
        }
    }


    // API CONNECT
    async function fetchCurrentDateAndEvents() {
        try {
            activateInfiniteLoop("#calendarContainer");

            // Prepare headers with nonce if available
            let headers = {
                'Content-Type': 'application/json'
            };
            if (typeof apiSettings !== 'undefined') {
                if (apiSettings.nonce) {
                    headers['X-WP-Nonce'] = apiSettings.nonce; // Include the nonce in the request headers
                }
            }

            const response = await fetch(prefixRequests + 'current-date', { headers: headers });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (!currentDateGlobal) { // Set only if not already set from query
                currentDateGlobal = new Date(data.currentDate);
                todayGlobal = new Date(data.currentDate);
            }
            currentTimeGlobal = data.currentTime;
            timeGlobal = data.currentTime;
            fetchEventsAndGenerateCalendar();
        } catch (error) {
            console.error('Error fetching current date:', error);
            deActivateInfiniteLoop();
        }
    }


    async function fetchEventsAndGenerateCalendar() {
        try {
            activateInfiniteLoop("#calendarContainer");
            const params = new URLSearchParams(window.location.search);
            token = params.get('tk');
            action = params.get('action');
            const url = token ? `${prefixRequests}get-availabilities?tk=${token}` : `${prefixRequests}get-availabilities`;

            // Prepare headers with nonce if available
            let headers = {
                'Content-Type': 'application/json'
            };
            if (typeof apiSettings !== 'undefined') {
                if (apiSettings.nonce) {
                    headers['X-WP-Nonce'] = apiSettings.nonce;
                }
            }

            const response = await fetch(url, { method: 'GET', headers: headers });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            deActivateInfiniteLoop();

            eventsData = groupEventsByDate(data.availabilities);
            generateCalendar();
            let currentDate = new Date(todayGlobal);
            let [hours, minutes, seconds] = timeGlobal.split(':').map(Number);
            currentDate.setHours(hours, minutes, seconds, 0);

            let bookingDateTime = new Date(`${data.bookingDate}T${data.bookingSlot}`);
            manageEventVisibility(bookingDateTime, currentDate, eventInThePast, eventInThePast_update, eventInThePast_delete, action, data);

            // Automatically show slots for the provided date
            if (eventsData[queryDate] && eventsData[queryDate].length > 0) {
                //showTimesContainer();
                showTimeSlots(queryDate, eventsData[queryDate], defaultColor);
                queryDate = "";
            }
        } catch (error) {
            console.error('Error fetching event data:', error);
            deActivateInfiniteLoop();
        }
    }

    function manageEventVisibility(bookingDateTime, currentDate, eventInThePast, eventInThePast_update, eventInThePast_delete, action, data) {
        if (bookingDateTime < currentDate) {
            if (eventInThePast) {
                eventInThePast.style.display = "block";
                if (action == "edit") {
                    eventInThePast_update.textContent = translations[lang].eventWarningUpdate;
                    eventInThePast_update.style.display = "block";
                }
                if (action == "delete") {
                    eventInThePast_delete.style.display = "block";
                    eventInThePast_delete.textContent = translations[lang].eventWarningCancel;
                }
            }
        }

        if (bookingDateTime > currentDate && data.tokenValid === true) {
            if (action == 'delete') {
                cancelModal(data.bookingDate, data.bookingName, data.bookingSlot, data.locationName);
            }
            if (action == 'edit') {
                userDetails = {
                    email: data.bookingEmail,
                    name: data.bookingName
                };
                updateModal(data.bookingDate, data.bookingName, data.bookingSlot, data.locationName);
            }
        }
    }


    function showTimesContainer() {
        const timesContainer = document.getElementById('timesContainerWrapper');
        timesContainer.style.display = 'none'; // Optionally hide the times container initially
        timesContainer.style.display = 'flex'; // Make sure to display the container if it was hidden
    }

    async function fetchLatestEventsAndShowSlotsForDay(dateStr, color) {
        // console.log("fetchLatestEventsAndShowSlotsForDay", dateStr, color)
        activateInfiniteLoop("#calendarContainer");

        // Construct the URL using the base URL from apiSettings
        const url = prefixRequests + 'get-availabilities';

        // Initialize headers object with default headers
        let headers = {
            'Content-Type': 'application/json'
        };

        // Conditionally add nonce to headers if it exists
        if (typeof apiSettings !== 'undefined') {
            if (apiSettings.nonce) {
                headers['X-WP-Nonce'] = apiSettings.nonce;
            }
        }

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            deActivateInfiniteLoop();
            eventsData = groupEventsByDate(data.availabilities);
            // console.log(eventsData)
            // showTimesContainer();
            showTimeSlots(dateStr, eventsData[dateStr], color);
        } catch (error) {
            console.error("Failed to fetch latest events:", error);
            deActivateInfiniteLoop();
        }
    }



    async function processFormSubmission(name, email, comments, availabilityId, slot, date, eventLocation, newsletter) {
        let headers = {
            'Content-Type': 'application/json'
        };

        // Conditionally add nonce to headers if it exists
        if (typeof apiSettings !== 'undefined') {
            if (apiSettings.nonce) {
                headers['X-WP-Nonce'] = apiSettings.nonce;
            }
        }
        try {
            activateInfiniteLoop("#calendarContainer")
            const trimmedComments = comments.trim();
            const response = await fetch(prefixRequests + 'booking/create', {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    name: name,
                    email: email,
                    comments: trimmedComments,
                    availabilityId: availabilityId,
                    slot: slot,
                    date: date,
                    eventLocation: eventLocation,
                    lang: lang,
                    newsletter: newsletter,
                })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            deActivateInfiniteLoop()
            const data = await response.json();
            // console.log("Submission successful", data);
            gtag_report_conversion(); // Google Ads Conversion
            if (typeof fbq === 'function') {
                fbq('track', 'CompleteBooking');
            }  // Track the booking completion with Meta Pixel
            return data; // This is now correctly being returned for await in handleFormSubmit
        } catch (error) {
            // console.error("Submission failed", error);
            throw error; // Rethrow the error to be caught in handleFormSubmit
        }
    }

    async function processFormUpdate(name, email, comments, availabilityId, slot, date, eventLocation) {
        let headers = {
            'Content-Type': 'application/json'
        };

        // Conditionally add nonce to headers if it exists
        if (typeof apiSettings !== 'undefined') {
            if (apiSettings.nonce) {
                headers['X-WP-Nonce'] = apiSettings.nonce;
            }
        }
        try {
            const response = await fetch(prefixRequests + 'booking/update', {
                method: 'PATCH',
                headers: headers,
                body: JSON.stringify({
                    availabilityId: availabilityId,
                    slot: slot,
                    token: token,
                })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            //console.log("Update successful", data);
            return data;
        } catch (error) {
            console.error("Update failed", error);
            throw error;
        }
    }
    async function deleteBooking() {
        let url = prefixRequests + `booking/delete`;
        let headers = {
            'Content-Type': 'application/json'
        };

        // Conditionally add nonce to headers if it exists
        if (typeof apiSettings !== 'undefined') {
            if (apiSettings.nonce) {
                headers['X-WP-Nonce'] = apiSettings.nonce;
            }
        }

        try {
            const response = await fetch(url, {
                method: 'DELETE', // Specify the DELETE method
                headers: headers,
                body: JSON.stringify({
                    token: token,
                })
            });

            // Check if the response is successful (status in the range 200-299)
            if (response.ok) {
                // Handle successful deletion
                console.log("Booking deleted successfully");
                return "Booking deleted";
            } else {
                throw new Error(`Server responded with status ${response.status}`);
            }
        } catch (error) {
            // Handle errors that occur during the fetch request or in processing the response
            console.error("Failed to delete booking:", error.message);
        }
    }

    async function cancelModal(date, name, slot, location_name) {
        const cancelModal = document.querySelector("#cancel-event-wrapper")
        const cancelEventLocationWrapper = document.querySelector("#cancel-event-location-wrapper");

        if (cancelModal) {
            cancelModal.style.display = "flex";
            let cancelEventNo = document.getElementById("cancel-event-button-no");
            let cancelEventYes = document.getElementById("cancel-event-button-yes");

            if (cancelEventLocationWrapper) {
                cancelEventLocationWrapper.innerHTML = `
                <p><strong>${name}</strong></p>
                <p>${location_name}</p>
                <p>${date} - ${slot}</p>
            `;
            }

            if (cancelEventNo) {
                cancelEventNo.addEventListener("click", async() => {
                    cancelModal.style.display = "none";
                    cancelEventLocationWrapper.innerHTML = "";
                });
            }
            if (cancelEventYes) {
                cancelEventYes.addEventListener("click", async() => {
                    cancelModal.style.display = "none";
                    cancelEventLocationWrapper.innerHTML = "";
                    let delResult = await deleteBooking()
                    showSuccessDeleteModal();
                });
            }
        }
    }


    function updateModal(date, name, slot, location_name) {

        const editWarning = document.querySelector("#editWarning");
        const editName = document.querySelector("#edit-name");
        const editDate = document.querySelector("#edit-date");
        const editTime = document.querySelector("#edit-time");
        const locationName = document.querySelector("#edit-locationName");

        if (editName) editName.textContent = name
        if (editDate) editDate.textContent = date
        if (editTime) editTime.textContent = slot
        if (locationName) locationName.textContent = location_name
        if (editWarning) editWarning.style.display = "block"


    }


    // Convert Hex to RGBA
    function hexToRgba(hex, alpha = 1) {
        let r = 0,
            g = 0,
            b = 0;
        // 3 digits
        if (hex.length == 4) {
            r = parseInt(hex[1] + hex[1], 16);
            g = parseInt(hex[2] + hex[2], 16);
            b = parseInt(hex[3] + hex[3], 16);
        }
        // 6 digits
        else if (hex.length == 7) {
            r = parseInt(hex[1] + hex[2], 16);
            g = parseInt(hex[3] + hex[4], 16);
            b = parseInt(hex[5] + hex[6], 16);
        }
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }


    // Function to ensure a unique class name based on the color
    function generateColorClassName(color) {
        if (!color) {
            return `hover-bg-${defaultColor}`;
        } else {
            return `hover-bg-${color}`;
        }
    }

    // Function to inject style for hover effect
    function injectHoverStyle(color, numEvents, currentIndex) {
        const className = generateColorClassName(color);
        // Check if this class style already exists to avoid duplicates
        if (!document.getElementById(className)) {
            const style = document.createElement('style');
            style.id = className; // Set an ID to track our injected style
            let styleContent = '';
            if (currentIndex === 1) {
                let backColor = hexToRgba('#' + color, 0.065);
                let backColorHover = hexToRgba('#' + color, 0.3);
                let textColor = hexToRgba('#' + color);

                styleContent = `
                    #calendar-days .has-event button.${className},
                    .timeSlotWrapper input[type="radio"]+label.${className} {
                            background-color: ${backColor};
                            color:  ${textColor};
                        }
                    #calendar-days .has-event button.${className}:hover {
                            background-color:  ${backColorHover};
                        }
                    `;
            }
            /*
            if (numEvents > 1 && currentIndex > 1) {
                //console.log(numEvents, currentIndex)
                // For second and subsequent events, apply border
                styleContent += `
                #calendar-days .has-event button.${className} {
                    border: 2px solid ${hexToRgba('#' + color, 0.8)};
                }
            `;
            }
            */

            style.innerHTML = styleContent;

            document.head.appendChild(style);
        }
    }

    // Example usage
    function applyEventStyle(dayElement, color, numEvents, currentIndex) {
        const className = generateColorClassName(color);
        injectHoverStyle(color, numEvents, currentIndex); // Ensure the style exists
        dayElement.classList.add(className); // Apply the class with the color and hover effect
        // console.log(dayElement, dayElement.classList)
    }


    // CALENDAR LOGIC
    function groupEventsByDate(events) {
        return events.reduce((acc, curr) => {
            (acc[curr.date] = acc[curr.date] || []).push(curr);
            return acc;
        }, {});
    }

    function generateCalendar() {
        const calendarContainer = document.getElementById('calendarContainer');
        calendarContainer.innerHTML = generateCalendarHTML();
        //const daysContainer = document.getElementById('calendar-days');
        renderDays();
        setupNavigationButtons();
        setupCalTitle();
        const form = document.getElementById('bookingForm');
        if (form) {
            form.addEventListener('submit', function(event) {
                event.preventDefault(); // Prevent the default form submission behavior
                // console.log(currentSelection.locationWrapper, currentSelection.event)
                handleFormSubmit(event, currentSelection.locationWrapper, currentSelection.event);
            });
        }
    }

    function generateCalendarHTML() {
        return calendarHTML;
    }

    function setupCalTitle() {
        let locationInfo = new Map(); // Use a Map to keep track of location names and colors

        let currentMonth = currentDateGlobal.getMonth(); // 0-based month index (0 = January, 11 = December)
        let currentYear = currentDateGlobal.getFullYear();

        // Iterate through each date's events
        Object.values(eventsData).forEach(dateEvents => {
            dateEvents.forEach(event => {
                // Parse the event date
                let eventDate = new Date(event.date);
                let eventMonth = eventDate.getMonth();
                let eventYear = eventDate.getFullYear();

                // Check if the event is in the current month and year
                if (eventMonth === currentMonth && eventYear === currentYear) {
                    // Store both the location name and color in the Map
                    let color = event.location.color === "" ? defaultColor : event.location.color;
                    let city = event.location.city;
                    let date = event.date;

                    // Only add the event if the location is not already in the map
                    if (!locationInfo.has(event.location.name)) {
                        locationInfo.set(event.location.name, { color, city, date });
                    }
                }
            });
        });


        let finalSentence;
        let locationElements = []; // Array to hold HTML for each location
        if (locationInfo.size > 0) {
            let locationsData = Array.from(locationInfo.entries());

            // Create the location strings for the final sentence
            let locationStrings = locationsData.map(([name, details]) => {
                return `${name} (${details.city})`;
            });

            let locationString = locationStrings.length > 1 ?
                locationStrings.slice(0, -1).join(", ") + " " + translations[lang].titleEventsAnd + " " + locationStrings[locationStrings.length - 1] :
                locationStrings[0];

            finalSentence = locationString;

            // Build HTML elements for each location
            locationsData.forEach(([name, details]) => {
                let liElement = `<li style="list-style-type: none;">
                                    <span class="citybullet" style=" background-color: #${details.color};"></span>
                                    <div class="locationname">${name} <span class="cityname">(${details.city})</span></div>
                                 </li>`;
                locationElements.push(liElement);
            });

        } else {
            finalSentence = translations[lang].noEventsPlanned;
            const calendarWrapper = document.querySelector("#calendar-wrapper")
            if (calendarWrapper) {
                checkNextMonthWrapper = document.createElement("div")
                checkNextMonthWrapper.classList.add("checkNextMonthWrapper")
                const checkNextMonth = `
                    <div class="checkNextMonth">
                    <p>${translations[lang].checkEventsNextMonth} <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg></p>
                    </div>
                `;
                checkNextMonthWrapper.innerHTML = checkNextMonth;
                checkNextMonthWrapper.addEventListener('click', () => {
                    currentDateGlobal.setDate(1);
                    currentDateGlobal.setMonth(currentDateGlobal.getMonth() + 1);
                    fetchEventsAndGenerateCalendar(); // Fetch events for the new month and re-generate the calendar
                });
                calendarWrapper.appendChild(checkNextMonthWrapper)
            }
            // console.log("We do not have any events planned.");
        }

        // Update the calendar title
        let calendarTitle = document.querySelector("#calendar-title");
        if (calendarTitle) {
            calendarTitle.innerHTML = finalSentence;
        }

        // Update the calendar caption
        let calendarCaption = document.querySelector("#calendar-caption");
        if (calendarCaption && locationElements.length > 0) {
            let ul = document.createElement('ul');
            locationElements.forEach(liHtml => {
                ul.innerHTML += liHtml; // Add each location as an li element
            });
            // Clear existing caption content before appending new content
            calendarCaption.innerHTML = '';
            calendarCaption.appendChild(ul); // Append the ul to the calendar-caption element
        }
    }



    function setupNavigationButtons() {
        const prevMonthBtn = document.createElement('button');
        prevMonthBtn.textContent = '←';
        const nextMonthBtn = document.createElement('button');
        nextMonthBtn.textContent = '→';
        const currentMonthDisplay = document.createElement('span');
        currentMonthDisplay.textContent = currentDateGlobal.toLocaleDateString('default', { month: 'long', year: 'numeric' });

        const header = document.getElementById('calendar-header');
        header.innerHTML = ''; // Clear the header to avoid duplicating buttons
        header.appendChild(prevMonthBtn);
        header.appendChild(currentMonthDisplay);
        header.appendChild(nextMonthBtn);
        prevMonthBtn.addEventListener('click', () => {
            currentDateGlobal.setDate(1);
            currentDateGlobal.setMonth(currentDateGlobal.getMonth() - 1);
            fetchEventsAndGenerateCalendar(); // Fetch events for the new month and re-generate the calendar
        });

        nextMonthBtn.addEventListener('click', () => {
            currentDateGlobal.setDate(1);
            currentDateGlobal.setMonth(currentDateGlobal.getMonth() + 1);
            fetchEventsAndGenerateCalendar(); // Fetch events for the new month and re-generate the calendar
        });

        // Optionally, disable the previous month button if it's the current month/year
        const now = new Date();
        if (currentDateGlobal.getFullYear() === now.getFullYear() && currentDateGlobal.getMonth() === now.getMonth()) {
            prevMonthBtn.disabled = true;
        }
    }

    function renderDays() {
        const daysGrid = document.getElementById('calendar-days');
        daysGrid.innerHTML = ''; // Clear existing days

        const year = currentDateGlobal.getFullYear();
        const month = currentDateGlobal.getMonth();

        // Calculate the index of the first day of the month
        // Calculate additional information
        const firstDayIndex = new Date(year, month, 1).getDay();
        const prevMonthDays = new Date(year, month, 0).getDate();
        const totalDaysInMonth = new Date(year, month + 1, 0).getDate();
        const daysFromPrevMonth = firstDayIndex;
        const totalDaysDisplayed = Math.ceil((totalDaysInMonth + daysFromPrevMonth) / 7) * 7;


        // Adding empty cells before the first day of the month
        for (let i = daysFromPrevMonth - 1; i >= 0; i--) {
            renderDayCell(prevMonthDays - i, new Date(year, month - 1, prevMonthDays - i), daysGrid);
        }

        // Render the actual days of the month
        for (let day = 1; day <= totalDaysInMonth; day++) {
            const date = new Date(year, month, day);
            renderDayCell(day, date, daysGrid);
        }

        // Render days from the next month
        for (let i = 1; i < totalDaysDisplayed - totalDaysInMonth - daysFromPrevMonth + 1; i++) {
            renderDayCell(i, new Date(year, month + 1, i), daysGrid);
        }
    }



    let currentlyActiveDayElement = null;

    function renderDayCell(day, date, container) {
        const dayElement = document.createElement('div');
        dayElement.classList.add('day');
        const dayElementBTN = document.createElement('button');
        dayElementBTN.type = 'button';
        dayElement.appendChild(dayElementBTN);

        if (date) {
            // Create a local date string in YYYY-MM-DD format
            const dateStr = date.getFullYear() + '-' +
                ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                ('0' + date.getDate()).slice(-2);

            if (date.getMonth() === currentDateGlobal.getMonth()) {
                // Rest of your code for setting up the day element
                dayElementBTN.textContent = day;
            }


            if (date.getDate() === todayGlobal.getDate() &&
                date.getMonth() === todayGlobal.getMonth() &&
                date.getFullYear() === todayGlobal.getFullYear()) {
                if (date.getMonth() === currentDateGlobal.getMonth())
                    dayElement.classList.add('today');
            }

            // Check if the day has events and add event listener
            if (eventsData && eventsData[dateStr] && date.getMonth() === currentDateGlobal.getMonth()) {
                dayElement.classList.add('has-event');

                if (eventsData[dateStr]) {
                    const numEvents = eventsData[dateStr].length
                    let cities = document.createElement("div")
                    cities.classList.add("cities")
                    if (numEvents > 1){
                        dayElement.appendChild(cities)
                    }
                    eventsData[dateStr].forEach((event, index) => {
                        let color = event.location.color;

                        if (color === "")
                            color = defaultColor
                        if (numEvents > 1){
                            let city = document.createElement("span")
                            city.classList.add("city")
                            city.setAttribute("style", "background-color:#"+color)
                            cities.appendChild(city)

                        }
                        applyEventStyle(dayElementBTN, color, numEvents, index + 1);
                    });
                }
                color = defaultColor

                dayElement.addEventListener('click', () => {
                    fetchLatestEventsAndShowSlotsForDay(dateStr, color);

                    // Handling the active class for clicked day element
                    if (currentlyActiveDayElement) {
                        currentlyActiveDayElement.classList.remove('active');
                    }
                    dayElement.classList.add('active');
                    currentlyActiveDayElement = dayElement;
                });
            }

            container.appendChild(dayElement);
        }
    }

    function showTimeSlots(dateStr, eventsForDay, color) {
        if (eventsForDay.length > 0) {
            if (eventsForDay.length === 1) {
                // Directly show slots if only one event is present
                //displayEventDetails(eventsForDay[0], dateStr);
                showEventSelectionModal(eventsForDay, dateStr);
            } else {
                // More than one event, show modal for user to choose
                showEventSelectionModal(eventsForDay, dateStr);
            }
        }
    }

    function showEventSelectionModal(eventsForDay, dateStr) {
        // console.log("showEventSelectionModal")
        const modalWrapper = document.createElement('div');
        modalWrapper.classList.add('event-selection-modal-wrapper');
        const modalWrapperContent = `
            <div class="event-selection-modal">
                <div class="closing-slots-button-wrapper">
                    <button type="button" class="closeBookingForm" id="closeBookingFormLocations">${closingIcon}</button>
                    <p class="time-slot__date" id="todayDate"></p>
                </div>
                <div class="event-options-header">

                    <h2>${translations[lang].multiplePlacesTitle}</h2>
                </div>
                <div class="event-options"></div>
                <div class="next-events"></div>
            </div>
        `;
        modalWrapper.innerHTML = modalWrapperContent;
        const eventOptions = modalWrapper.querySelector(".event-options")
        const nextEvents = modalWrapper.querySelector(".next-events")
        const closeBookingFormLocations = modalWrapper.querySelector("#closeBookingFormLocations")
        if (closeBookingFormLocations) closeBookingFormLocations.addEventListener('click', hideEventSelectionModal);

        eventsForDay.forEach(event => {
            // console.log("Slots ", event)
            const eventOption = document.createElement('div');
            eventOption.classList.add('event-option');
            const spanElement = document.createElement('span');
            spanElement.classList.add("locationName")
            eventOption.appendChild(spanElement);
            spanElement.textContent = event.location.name + (event.location.city ? ` (${event.location.city})` : '');
            let todayDate = modalWrapper.querySelector("#todayDate")
            todayDate.innerHTML = event.formattedDate;
            if (event.times.length > 0){
                const arrowSpan = document.createElement('span'); // Span to hold the arrow
                arrowSpan.classList.add('arrow');
                arrowSpan.textContent = ' ➔';
                eventOption.appendChild(arrowSpan);
                eventOption.onclick = () => {
                    closeModal(modalWrapper);
                    displayEventDetails(event, dateStr);
                };
            }
            if (event.times.length == 0){
                const arrowSpan = document.createElement('span');
                arrowSpan.classList.add('fullBooked');
                eventOption.classList.add('fullBooked-wrapper');
                arrowSpan.innerHTML = `(${translations[lang].fullyBooked})`
                eventOption.appendChild(arrowSpan);
                const selectedEvent = event;

                if (Array.isArray(selectedEvent.times) && selectedEvent.times.length === 0) {
                    const locationCity = selectedEvent.location.city;

                    // Loop through all dates in eventsData
                    const alternativeDates = Object.keys(eventsData)
                        .flatMap(date => eventsData[date]) // Get the array of events for each date
                        .filter(e => e.location.city === locationCity && Array.isArray(e.times) && e.times.length > 0)
                        .map(e => ({ date: e.date, city: e.location.city, formattedDate: e.formattedDate, times: e.times }));

                    if (alternativeDates.length > 0) {
                        const nextEvent = alternativeDates[0];
                        //console.log("nextEvent", nextEvent.date)
                        const nextEventElem = document.createElement('p');
                        nextEventElem.classList.add('nextEvent');
                        nextEventElem.innerHTML = `<div>${translations[lang].nextEventOnThisCityWillBe} ${nextEvent.city} ${translations[lang].nextEventOnThisCityDay} ${nextEvent.formattedDate} <span class="arrow"> ➔</span></div>`
                        nextEventElem.onclick = () => {
                            closeModal(modalWrapper);
                            specificDate(nextEvent.date);
                        };
                        nextEvents.appendChild(nextEventElem);
                    } else {
                        console.log("Fully booked. No other dates available for this location.");
                    }
                } else if (Array.isArray(selectedEvent.times) && selectedEvent.times.length > 0) {
                    console.log(`Available times for ${selectedEvent.formattedDate}: ${selectedEvent.times.join(', ')}`);
                } else {
                    console.log("No event found for this date or invalid structure.");
                }
            }
            eventOptions.appendChild(eventOption);
        });
        let calendarContainer = document.querySelector("#calendar-wrapper-main")
        if (calendarContainer)
            calendarContainer.appendChild(modalWrapper);
    }

    function closeModal() {
        let modalWrapper = document.querySelector(".event-selection-modal-wrapper")
        modalWrapper.remove();
        // Reset all selected days with "active"
    }

    function displayEventDetails(event, dateStr) {
        showTimesContainer();
        const timesContainer = document.getElementById('timesContainer');
        timesContainer.innerHTML = ''; // Clear previous content
        timesContainer.style.display = 'flex'; // Make the container visible

        const closingSlotsButtonWrapper = document.createElement('div');
        closingSlotsButtonWrapper.classList.add('closing-slots-button-wrapper');
        const closingSlotsButton = document.createElement('button');
        closingSlotsButton.id = "closeBookingForm";
        closingSlotsButton.innerHTML = closingIcon;
        closingSlotsButton.addEventListener('click', removeSlots);
        closingSlotsButtonWrapper.appendChild(closingSlotsButton);
        const date = document.createElement('p');
        date.classList.add('time-slot__date');
        date.textContent = `${dateStr}`;
        closingSlotsButtonWrapper.appendChild(date)
        timesContainer.appendChild(closingSlotsButtonWrapper);

        // Create and append the header elements for the selected event
        const locationWrapper = document.createElement('div');
        locationWrapper.classList.add('location-wrapper');

        const headerSlots = document.createElement('header');
        headerSlots.classList.add('time-slot__header');

        const title = document.createElement('h3');
        title.classList.add('time-slot__title');
        title.innerHTML = event.location.name + `<span class="time-slot__city"> (${event.location.city})</span>`;

        // const city = document.createElement('p');
        // city.classList.add('time-slot__city');
        // city.textContent = event.location.city ? `(${event.location.city})` : '';

        headerSlots.appendChild(title);
        // headerSlots.appendChild(city);

        if (event.location.address) {
            //const address = document.createElement('p');
            // address.classList.add('time-slot__address');
            // address.innerHTML = event.location.address;

            if (event.location.location_link) {
                const address = document.createElement('p');
                address.classList.add("address_link")
                address.innerHTML += ` <span class="time-slot__address_link">(<a href="${event.location.location_link}" target="_blank">Directions</a>)</span>`;
                headerSlots.appendChild(address);
            }

        }

        locationWrapper.appendChild(headerSlots);

        // Intro text for timeslots
        const timeIntro = document.createElement('div');
        timeIntro.classList.add('time-slot__intro');
        timeIntro.textContent = 'Available Timeslots:';

        locationWrapper.appendChild(timeIntro);

        // Timeslots container
        const timeslotswrapper = document.createElement('div');
        timeslotswrapper.classList.add('time-slot-container');

        // Iterate through each time and create an interactive element for it
        event.times.forEach((time, index) => {
            const slotWrapper = document.createElement('div');
            let elemID = "eventslot_" + event.location.location_id + "_" + index;
            let nextBtn = document.createElement('div');
            nextBtn.classList.add("next")
            nextBtn.innerHTML = `<span>Next</span> <span class="timebtn">${time}</span>`;
            const slotElem = `
                        <input type="radio" value="${time}" name="slotTime" id="${elemID}">
                        <label for="${elemID}" class="${color}">${time}</label>
                    `;
            slotWrapper.classList.add("timeSlotWrapper")
            slotWrapper.innerHTML = slotElem;
            slotWrapper.appendChild(nextBtn)
            timeslotswrapper.appendChild(slotWrapper);
            // console.log(event)

            // Event
            var clonedHeaderSlots = headerSlots.cloneNode(true);
            if (nextBtn) {
                // nextBtn.addEventListener('click', () => selectTimeSlot(time, clonedHeaderSlots, event));
                nextBtn.addEventListener('click', () => {
                    currentSelection = { slot: time, locationWrapper: clonedHeaderSlots, event: event };
                    //console.log("Current selection updated:", currentSelection);
                    updateUI(currentSelection);
                });
            }
        });

        locationWrapper.appendChild(timeslotswrapper);
        timesContainer.appendChild(locationWrapper);
    }




    function updateUI(selection) {
        const { slot, locationWrapper, event } = selection;
        //console.log("Updating UI with slot:", slot, "and event:", event);

        //Hide Slots
        const timesContainerWrapper = document.querySelector("#timesContainerWrapper")
        if (timesContainerWrapper)
            timesContainerWrapper.style.display = "none"

        // Show or update form elements based on whether it's an edit or a new booking
        const formWrapper = document.querySelector("#booking-form-wrapper");
        // const bFormSlot = document.querySelector("#bookingFormSlot");
        // const bFormDate = document.querySelector("#bookingFormDate");
        const bFormAvailabilityIdHF = document.querySelector("#booking-form-wrapper #availabilityId");
        const bFormSlotHF = document.querySelector("#booking-form-wrapper #slot");
        const bFormDateHF = document.querySelector("#booking-form-wrapper #date");
        const bFormUserName = document.querySelector("#booking-form-wrapper #userName");
        const bFormUserEmail = document.querySelector("#booking-form-wrapper #userEmail");
        const formLocationWrapper = document.querySelector("#formLocationWrapper");

        // Update hidden fields and visible text
        if (bFormAvailabilityIdHF) bFormAvailabilityIdHF.textContent = event.id;
        // if (bFormSlot) bFormSlot.textContent = slot;
        // if (bFormDate) bFormDate.textContent = event.formattedDate;
        // console.log("event", event, slot, locationWrapper)
        // Clone the original element
        const locationClone = locationWrapper.cloneNode(true);

        // Select and remove the time-slot__address_link element in the clone
        const addressLinkInClone = locationClone.querySelector('.time-slot__address_link');
        if (addressLinkInClone) {
            addressLinkInClone.remove();
        }

        // Select the h3 element
        const h3Element = locationClone.querySelector('.time-slot__title');

        // Create the new element you want to insert
        const newElement = document.createElement('div');
        newElement.classList.add('formatted-date'); // Add any class you want
        newElement.textContent = `${event.formattedDate} ${translations[lang].bookingConfirmedAt} ${slot}`; // Set the content for the new element

        // Insert the new element after the h3
        h3Element.insertAdjacentElement('afterend', newElement);

        if (bFormSlotHF) bFormSlotHF.value = slot;
        if (bFormDateHF) bFormDateHF.value = event.date;
        if (formLocationWrapper) formLocationWrapper.innerHTML = locationClone.outerHTML;

        // Update form fields or show/hide elements based on 'action' and selection
        if (action === "edit") {
            bFormUserName.value = userDetails.name;
            bFormUserEmail.value = userDetails.email;
        } else {
            bFormUserName.value = ""; // Clear previous data
            bFormUserEmail.value = ""; // Clear previous data
        }
        const closeBookingFormModal = document.querySelector("#closeBookingFormModal")
        if (closeBookingFormModal) closeBookingFormModal.addEventListener('click', removeForm);
        formWrapper.style.display = "block"; // Show form
    }

    function removeSlots() {
        // Reset all selected days with "active"
        let days = document.querySelectorAll('.day.active');
        days.forEach(function(day) {
            day.classList.remove('active')
        });

        var locationWrapper = document.getElementById('locationWrapper');
        if (locationWrapper) {
            locationWrapper.remove(); // This removes the form from the DOM
        }

        const timesContainer = document.getElementById('timesContainerWrapper');
        timesContainer.style.display = 'none';
    }

    function hideEventSelectionModal(){
        // console.log("hideEventSelectionModal")
        const timesContainerWrapper = document.querySelector("#timesContainerWrapper")
        if (timesContainerWrapper)
            timesContainerWrapper.style.display = "none"

        let modalWrapper = document.querySelector(".event-selection-modal-wrapper")
        modalWrapper.remove();
        let days = document.querySelectorAll('.day.active');
        days.forEach(function(day) {
            day.classList.remove('active')
        });
    }

    function removeForm() {
        const timesContainerWrapper = document.querySelector("#timesContainerWrapper")
        if (timesContainerWrapper)
            timesContainerWrapper.style.display = "none"
            // console.log("removeForm")
            // Reset all radio buttons named 'slotTime'
        const radios = document.querySelectorAll('input[type="radio"][name="slotTime"]');
        radios.forEach(function(radio) {
            radio.checked = false;
        });

        const formWrapper = document.getElementById('booking-form-wrapper');
        formWrapper.style.display = "none";
        //console.log("formWrapper set to display none")

        const form = document.getElementById('bookingForm');
        form.reset(); //
    }

    async function handleFormSubmit(event, locationWrapper, calendarEvent) {
        event.preventDefault(); // Prevent the default form submission behavior

        // Initialize an array to hold any error messages
        let errors = [];

        // Access form fields using their IDs or names
        const form = document.getElementById('bookingForm');
        const name = form.userName ? form.userName.value.trim() : '';
        const email = form.userEmail ? form.userEmail.value.trim() : '';
        const comments = form.comments ? form.comments.value.trim() : '';
        const newsletter = form.newsletter ? form.newsletter.checked : false;


        // Validate Name (must be at least two characters long)
        if (!name || name.length < 2) {
            errors.push("Name must be at least two characters long.");
        }

        // Validate Email (custom validation to ensure format including a dot and at least two characters after it)
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            errors.push("Please enter a valid email address (with a dot and at least two characters after).");
        }

        // Find the div to display form errors
        const formErrors = document.getElementById('formErrors');

        // Display Errors or Process the Form
        if (errors.length > 0) {
            // Join all errors into a single string with line breaks and set it as the innerHTML of the error display div
            formErrors.innerHTML = errors.join('<br>');
            formErrors.style.display = 'block'; // Make the error display div visible
        } else {

            // If there are no errors, hide the error display div and proceed with form submission
            formErrors.style.display = 'none';
            //console.log("Form is valid. Processing submission...");
            try {


                if (action !== "edit") {
                    let formResult = await processFormSubmission(name, email, comments, calendarEvent.id, slot.value, date.value, calendarEvent.location, newsletter);
                    showSuccessModal(formResult, locationWrapper);
                }
                if (action === "edit") {
                    let formResult = await processFormUpdate(name, email, comments, calendarEvent.id, slot.value, date.value, calendarEvent.location);
                    showSuccessUpdateModal(formResult, locationWrapper);
                }
                // Handle successful form submission here (e.g., showing a success message)
            } catch (error) {
                // Update the UI to show the error message
                formErrors.textContent = 'There was a problem with your submission. Please try again. ' + error;
                formErrors.style.display = 'block';
            }
        }
    }

    function showSuccessModal(formResult, locationWrapper) {
        let successModalWrapper = document.querySelector("#successModalWrapper")
        let locationWrapperElem = document.querySelector("#locationWrapper")
            // let bookingFormWrapper = document.querySelector("#booking-form-wrapper")
        let calendarWrapper = document.querySelector("#calendar-wrapper")

        const successModalSlot = document.querySelector("#success-modal-slot");
        //console.log("formResult", formResult)
        successModalSlot.innerHTML = `${formResult.formattedDate}  ${translations[lang].bookingConfirmedAt}  ${formResult.slot}`;
        const successModalLocationWrapper = document.querySelector("#success-modal-location-wrapper");
        successModalLocationWrapper.innerHTML = locationWrapper.outerHTML;
        //successModalWrapper.innerHTML = successModal;
        successModalWrapper.style.display = "block"
        if (locationWrapperElem)
            locationWrapperElem.remove()
        calendarWrapper.remove()
        removeForm();

        let closeBtn = document.getElementById("successModalBTN");
        closeBtn.onclick = function() {
            successModalWrapper.innerHTML = "";
            fetchCurrentDateAndEvents();
        };
    }

    function showSuccessUpdateModal(formResult, locationWrapper) {
        let successModalWrapper = document.querySelector("#successUpdateModalWrapper")
        let locationWrapperElem = document.querySelector("#locationWrapper")
        let calendarWrapper = document.querySelector("#calendar-wrapper")

        const successModalSlot = document.querySelector("#success-modal-update-slot");
        successModalSlot.innerHTML = formResult.slot;
        const successModalLocationWrapper = document.querySelector("#success-modal-update-location-wrapper");
        successModalLocationWrapper.innerHTML = locationWrapper.outerHTML;
        //successModalWrapper.innerHTML = successModal;
        successModalWrapper.style.display = "block"
        if (locationWrapperElem)
            locationWrapperElem.remove()
        calendarWrapper.remove()
        removeForm();

        let closeBtn = document.getElementById("successUpdateModalBTN");
        closeBtn.onclick = function() {
            successModalWrapper.innerHTML = "";
            history.replaceState(null, '', window.location.pathname);
            fetchCurrentDateAndEvents();
        };
    }

    function showSuccessDeleteModal(formResult, locationWrapper) {
        let successModalWrapper = document.querySelector("#successDeleteModalWrapper")
        let calendarWrapper = document.querySelector("#calendar-wrapper")
            //successModalWrapper.innerHTML = successModal;
        successModalWrapper.style.display = "block"
        calendarWrapper.remove()
        removeForm();

        let closeBtn = document.getElementById("successDeleteModalBTN");
        closeBtn.onclick = function() {
            successModalWrapper.innerHTML = "";
            history.replaceState(null, '', window.location.pathname);
            fetchCurrentDateAndEvents();
        };
    }

})();